import React from "react";
import { Container } from "@prestosports/commons-ui";
import { matchPath, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import NavigationTabPanel from "../../season/components/NavigationTabPanel";
import GameHeader from "../components/GameHeader";
import { useTeamsContext } from "../../../state/teams/context";
import TeamDetails from "../components/TeamDetails";
import commonStyles from "../../common/styles/Common.styles";
import TeamPlayersContainer from "../../common/containers/TeamPlayersContainer";
import TeamImportContainer from "./TeamImportContainer";
import PlayerListContainer from "./PlayerListContainer";
import AddPlayerContainer from "./AddPlayerContainer";
import CsvSampleFileButton from "../components/CsvSampleFileButton";
import { GameRoutes } from "../../../routes/game-routes";

const TeamInfoContainer = () => {
	const commonClasses = commonStyles();
	// const params = useParams();
	// const { teamSide } = params;
	const { pathname } = useLocation();
	const match = matchPath({ path: GameRoutes.TEAM_INFORMATION.url }, pathname);
	const { teamSide } = match.params;

	const { state: teamState } = useTeamsContext();
	let team = null;
	if (teamSide === "away") {
		team = teamState.awayTeam();
	} else if (teamSide === "home") {
		team = teamState.homeTeam();
	}

	const getTabItems = () => {
		const tabItems = [];

		tabItems.push({
			label: "Team Details",
			tab: "details",
			component: <TeamDetails team={team} />
		});

		tabItems.push({
			label: "Rosters",
			tab: "roster",
			component: (
				<TeamPlayersContainer
					team={team}
					TeamImportContainer={TeamImportContainer}
					AddPlayerContainer={AddPlayerContainer}
					PlayerListContainer={PlayerListContainer}
					CsvDownloadButton={CsvSampleFileButton}
				/>
			)
		});

		return tabItems;
	};

	return team ? (
		<>
			<GameHeader
				title={team.teamName}
				description="Edit a team by entering the information below."
			/>
			<Box className={commonClasses.infoContainer}>
				<Container fullHeight>
					<NavigationTabPanel items={getTabItems()} />
				</Container>
			</Box>
		</>
	) : null;
};

export default TeamInfoContainer;
